// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { IconMail, IconArrowLeft, IconShieldLock, IconLock, IconKey, IconAlertCircle } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function ForgotSplit() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password for:', email);
  };

  const securityTips = [
    { icon: IconLock, text: 'Use a unique password for each account' },
    { icon: IconKey, text: 'Create passwords with at least 12 characters' },
    { icon: IconAlertCircle, text: 'Never share your password with anyone' },
  ];

  const splitContent = (
    <Stack gap="xl" p="xl" style={{ color: 'white' }}>
      <div>
        <Title order={1} c="white" mb="md">Password Security Tips</Title>
        <Text size="lg" style={{ opacity: 0.9 }}>
          Keep your account safe with these best practices.
        </Text>
      </div>

      <Stack gap="lg" mt="xl">
        {securityTips.map((tip, index) => (
          <Group key={index} gap="md">
            <Center
              style={{
                width: 48,
                height: 48,
                borderRadius: 12,
                backgroundColor: 'rgba(255,255,255,0.15)',
              }}
            >
              <tip.icon size={24} />
            </Center>
            <Text size="sm" style={{ flex: 1, opacity: 0.9 }}>
              {tip.text}
            </Text>
          </Group>
        ))}
      </Stack>

      <Center mt="xl">
        <IconShieldLock size={120} style={{ opacity: 0.3 }} />
      </Center>
    </Stack>
  );

  return (
    <AuthLayoutWrapper
      variant="split"
      splitContent={splitContent}
      gradientFrom="#f97316"
      gradientTo="#ea580c"
      backgroundImage="https://images.unsplash.com/photo-1557683304-673a23048d34?w=1200&auto=format&fit=crop"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/forgot-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <div>
          <Title order={2}>Reset your password</Title>
          <Text c="dimmed" size="sm" mt="xs">
            Enter your email and we'll send you a link to reset your password.
          </Text>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email address"
              placeholder="name@company.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              description="We'll send a password reset link to this email"
            />

            <Button type="submit" fullWidth color="orange">
              Send reset link
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Text ta="center" size="sm">
          Remember your password?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/login/split" fw={500}>
            Sign in
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
